import React from 'react';

// Panel header for the Report, Feedback and Support screens.
//
// A black five-sided marker — a square tapering to a point at the bottom —
// carrying the white AI mark, with the heading set beside it. A hairline drops
// from the marker's point and turns right, running out to the full width of the
// panel and separating the header from the body beneath it.
//
// The stem is offset by half the marker's width so it leaves the point exactly,
// which is why MARK_SIZE is a constant rather than a literal in three places.
const MARK_SIZE = 64;
const PIN = 'polygon(0 0, 100% 0, 100% 72%, 50% 100%, 0 72%)';

const AiPill = ({ children }) => (
  <div className="w-full">
    <div className="flex items-center gap-5">
      <span
        className="flex flex-shrink-0 items-start justify-center bg-black pt-3"
        style={{ width: MARK_SIZE, height: MARK_SIZE, clipPath: PIN }}
      >
        <img
          src="/mockup_images/marketing-remodel/AI-logoSmallWhite.png"
          alt=""
          className="h-7 w-auto"
        />
      </span>
      <h2 className="text-2xl font-bold text-black">{children}</h2>
    </div>

    {/* Elbow: down from the point, then right across the panel. */}
    <div aria-hidden="true" style={{ paddingLeft: MARK_SIZE / 2 }}>
      <div className="h-6 w-px bg-black" />
      <div className="h-px w-full bg-black" />
    </div>
  </div>
);

export default AiPill;
